<template lang="pug">
  .main(style="height: 100vh")
    el-row(style="height: 100vh")
      el-col.menu__container(:span="isMenuCollapsed ? 1 : 3")
        .balance__container(v-if="!isMenuCollapsed")
          .balances__block
            .balance__value
              span.mr5 Текущий:
              span {{ balance }} BTC
              span.balance__separator |
              span.mr5 {{ balanceUsdt }} USDT
            .balance__value
              span.mr5 Доступный:
              span {{ balanceAvailable }} BTC
              span.balance__separator |
              span.mr5 {{ balanceAvailableUsdt }} USDT
            .balance__value
              span.mr5 Активный:
              span {{ balanceDep }} BTC
              span.balance__separator |
              span.mr5 {{ balanceDepUsdt }} USDT
        .menu__block
          el-menu.el-menu-vertical-demo.menu__list(:default-active="lastMenuIndex" :collapse="isMenuCollapsed" :collapse-transition="false")
            .menu-width-handler__container(@click="handleFullMenuStatus" :class="{ collapsed: isMenuCollapsed }")
              i.el-icon-caret-right(v-if="isMenuCollapsed")
              i.el-icon-caret-left(v-else)
            .menu__item(v-for="(menu, key) in availableMenus" :key="`menu-${menu.name}`")
              el-submenu(v-if="menu.isSubMenu" :index="`${key}`")
                template(slot="title")
                  i(:class="menu.icon")
                  span(:class="{ hidden: isMenuCollapsed }") {{ menu.title }}
                router-link(
                  v-for="(submenu, submenuKey) in menu.menuList"
                  :key="`menu-${menu.name}-submenu-${submenu.name}`"
                  :to="{name: submenu.name}"
                  v-if="submenu.access.includes(role)"
                  tag="div"
                )
                  el-menu-item(:index="`${key}-${submenuKey}`" @click="saveLastMenuIndex(`${key}-${submenuKey}`)") {{ submenu.title }}
              router-link(
                v-else
                :to="{name: menu.name}"
                tag="div"
              )
                el-menu-item(:index="`${key}`" @click="saveLastMenuIndex(`${key}`)")
                  i(:class="menu.icon")
                  span(slot="title") {{ menu.title }}
            el-menu-item(:index="`${logoutIndex}`" @click="logout")
              i.el-icon-switch-button
              span(slot="title") Выйти
      el-col(:span="isMenuCollapsed ? 23 : 21" style="height: 100vh")
        .view-title__container
          .view-title__name(v-if="meta.title") {{ meta.title }}
          .current-user__container
            .current-user__name {{ username }}
            i.el-icon-refresh.current-user-switch__btn(@click="openLogin()")
            i.el-icon-warning.current-user-switch__btn(@click="clearStorage()")
        router-view
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CHANGE_RELOAD_STATUS } from '../../store/const/index';
import { AUTH_LOGOUT, LOAD_BALANCE, LOAD_PROJECTS, LOAD_USERS_PROJECTS } from '@/store/const/user';
import instruments from '../../mixins/instruments';

export default {
  name: 'Index',
  mixins: [instruments],
  data() {
    return {
      menuList: [
        {
          name: 'Orders',
          title: 'Заявки',
          icon: 'el-icon-sell',
          access: ['superadmin', 'client'],
        },
        {
          name: 'Users',
          title: 'Пользователи',
          icon: 'el-icon-user',
          access: ['superadmin'],
        },
        {
          name: 'Stats',
          title: 'Статистика',
          icon: 'el-icon-s-data',
          access: ['superadmin']
        },
        {
          name: 'Settings',
          title: 'Настройки',
          icon: 'el-icon-setting',
          access: ['superadmin'],
          isSubMenu: true,
          menuList: [
            {
              name: 'Settings',
              title: 'Глобальные',
              access: ['superadmin'],
            },
            {
              name: 'SaudiAccounts',
              title: 'Аккаунты Saudi',
              access: ['superadmin'],
            },
          ]
        },
      ],
      intervalHandle: null,
      isMenuCollapsed: false,
      lastMenuIndex: localStorage.getItem('menu_index') || '0',
    };
  },
  watch: {
    reload(reload) {
      if (reload) {
        this.changeReloadStatus({ status: false });
        this.$router.go();
      }
    },
  },
  async mounted() {
    await this.updateProjects();
    await this.updateBalance();
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters('user', {
      role: 'getRole',
      isAdmin: 'isAdmin',
      balance: 'balance',
      balanceDep: 'balanceDep',
      balanceAvailable: 'balanceAvailable',
      balanceUsdt: 'balanceUsdt',
      balanceDepUsdt: 'balanceDepUsdt',
      balanceAvailableUsdt: 'balanceAvailableUsdt',
      username: 'username',
    }),
    ...mapGetters(['reload']),
    availableMenus() {
      return this.menuList.filter((menu) => menu.access.includes(this.role));
    },
    logoutIndex() {
      return this.availableMenus.length;
    },
    activeMenu() {
      let activeMenu = '0';
      for (let i = 0; i < this.menuList.length; i++) {
        const menu = this.menuList[i];
        if (this.$route.name === menu.name) {
          activeMenu = '' + i;
          break;
        }
      }
      return activeMenu;
    },
    meta() {
      return this.$route.meta;
    }
  },
  methods: {
    ...mapActions({
      changeReloadStatus: CHANGE_RELOAD_STATUS,
    }),
    ...mapActions('user', {
      logoutRequest: AUTH_LOGOUT,
      loadBalance: LOAD_BALANCE,
      loadProjects: LOAD_PROJECTS,
      loadUsersProjects: LOAD_USERS_PROJECTS,
    }),
    async logout() {
      await this.logoutRequest();
    },
    handleFullMenuStatus() {
      this.isMenuCollapsed = !this.isMenuCollapsed;
    },
    async updateBalance() {
      await this.loadBalance();
    },
    async updateProjects() {
      if (this.isAdmin) {
        await this.loadUsersProjects();
      } else {
        await this.loadProjects();
      }
    },
    startInterval() {
      this.intervalHandle = setInterval(() => {
        this.updateBalance();
        this.updateProjects();
      }, 10000);
    },
    async openLogin() {
      await this.$router.push({ name: 'Login' });
    },
    async clearStorage() {
      this.$confirm('Данное действие сбросит все активные сессии!', 'Сброс сессий').then(() => {
        localStorage.clear();
        this.$router.go(0);
      }).catch(() => {
        this.$message('Сброс сессий отменен')
      })
    },
    saveLastMenuIndex(index) {
      localStorage.setItem('menu_index', index);
    }
  },
};
</script>

<style lang="scss">
.view-title__container {
  display: flex;
  font-size: 20px;
  height: 29px;
  padding: 10px;
  background-color: #efefef;
  text-shadow: 1px 1px 1px #cce0f1;
  color: #05447a;
  font-weight: bold;
  text-align: center;
}

.view-title__name {
  flex: 1
}

.current-user__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.current-user-switch__btn {
  margin-left: 10px;
  cursor: pointer;
}

.main {
  text-align: left;
}

.menu__list {
  height: 100%;
}

.mode-select__container {
  padding: 10px 0;
  margin: auto;
  text-align: center;
  border-bottom: 1px solid #e6e6e6;
}

.mode-select__container .title {
  font-weight: 500;
  margin-bottom: 5px;
}

.module__main {
  overflow-y: hidden;
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
}

.module__title {
  font-size: 20px;
  height: 29px;
  padding: 10px;
  background-color: #efefef;
  text-shadow: 1px 1px 1px #cce0f1;
  color: #05447a;
  font-weight: bold;
  text-align: center;
}

.module-content__container {
  display: flex;
  flex-direction: column;
  padding: 5px;
  background-color: #e3e0e0;
  border-left: 1px solid #d1cece;
  border-top: 1px solid #d1cece;
  overflow-y: hidden;
  height: 100%;
}

.menu__container {
  display: flex;
  height: 100vh;
  flex-direction: column;
  background-color: #efefef;
  padding: 4px;
}

.menu__block {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-right: solid 1px #e6e6e6;
  justify-content: space-between;
}

.menu-width-handler__container {
  cursor: pointer;
  width: 100%;
  text-align: right;
}

.menu-width-handler__container.collapsed {
  text-align: center;
}

.menu-width-handler__container:hover {
  background-color: #f7f7f7;
}

.table__container {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.table-list__container {
  overflow-y: scroll;
  border-radius: 5px;
}

.table-pagination__container {
  margin-bottom: 5px;
  text-align: center;
}

.table-list__container .val {
  text-overflow: ellipsis;
  word-break: break-word;
}

.color-success {
  color: #67c23a;
}

.background-success {
  background-color: #67c23a;
}

.color-warning {
  color: #e6a23c;
}

.background-warning {
  background-color: #e6a23c;
}

.color-danger {
  color: #f56c6c;
}

.background-danger {
  background-color: #f56c6c;
}

.color-info {
  color: #909399;
}

.background-info {
  background-color: #909399;
}

.color-primary {
  color: #409eff;
}

.background-primary {
  background-color: #409eff;
}

tr.row-success {
  background-color: #c4f8ae !important;
}

tr.row-danger {
  background-color: #fcbbbb !important;
}

.balance__container {
  padding: 4px;
  font-size: 10px;
  background-color: white;
  width: calc(100% - 10px);
  text-align: center;
  border-bottom: 1px solid #c9c9c9;
}

.balance__title {
  font-weight: bold;
}

.balance__value {
  margin-bottom: 2px;
}

.balances__block {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.balance__block {
  margin: 1px 2px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .blockchain-logo {
    width: 12px;
    height: auto;
    display: block;
  }
}

.mr5 {
  margin-right: 5px;
}

.ml5 {
  margin-left: 5px;
}

.mt5 {
  margin-top: 5px;
}

.mb5 {
  margin-bottom: 5px;
}

.mr10 {
  margin-right: 10px;
}

.ml10 {
  margin-left: 10px;
}

.mt10 {
  margin-top: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.hidden {
  display: none;
}

.dialog__container {
  padding: 6px;
  background-color: #f1f1f1;
  border: 1px solid #e5dddd;
  border-radius: 4px;
}

.dialog-input__block {
  padding: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid #e3e3e3;
}

.dialog-input__title {
  font-weight: 500;
  padding: 1px;
  margin-bottom: 3px;
}

.dialog__buttons {
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #97999f;
}

.dialog-input__required {
  padding: 1px;
  color: red;
  font-weight: bold;
}

.dialog-input__required::after {
  content: "*";
}

.flex-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cursor-pointer {
  cursor: pointer;
}

.balance__separator {
  margin-left: 2px;
  margin-right: 2px;
}
</style>
